import config from '../config';
import { useUserAssetsStore } from './useUserAssetsStore';

export const useCollabAssets = (city) => {
  const { userAssets } = useUserAssetsStore();

  const metadata = Object.values(city.metadata?.properties || {})
    .filter((p) => typeof p === 'string' && p.includes(' - '))
    .map((p) => parseInt(p.split(' - ')[1]))
    .flat();
  const collabBlocks = Object.values(config.collabBlocks).filter((c) => metadata.includes(c.blockId));

  const myCollabAssets = userAssets
    .filter((a) => {
      const theCollabAssets = collabBlocks.map((c) => c.assets).flat();
      return theCollabAssets.includes(a['asset-id']);
    })
    .map((a) => {
      return {
        ...a,
        collection: Object.values(config.collabBlocks).find((c) => c.assets.flat().includes(a['asset-id']))?.collection,
        isCollab: true,
      };
    });

  return { myCollabAssets };
};
